module.exports = __webpack_public_path__ + "media/images/signatures/stamp-998e999372d91d37efc8dbc6ab629ac2.png";